import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb } from 'lucide-react';
import { AppState } from '../../app/types';
import { GroupId } from '../../config/systemConfig';
import { Card } from '../ui/Card';
import { itemVariants } from '../shared/animations';
import { useErrorPatterns } from '../../utils/errorPatterns';
// Re-export for any historic consumers that import from this file
// (audit DDD-3, ronde 2 2026 — implementation moved to
// `src/utils/errorPatterns.ts` so the mascot domain can consume it
// without depending on this progress UI module).
export { useErrorPatterns } from '../../utils/errorPatterns';
interface ErrorPatternsSectionProps {
  state: AppState;
  selectedGroup: GroupId;
}
export function ErrorPatternsSection({
  state,
  selectedGroup
}: ErrorPatternsSectionProps) {
  const errorPatterns = useErrorPatterns(state, selectedGroup);
  return <div className="space-y-4" data-id="element-1771">
      <div className="flex items-center gap-3 px-1" data-id="element-1772">
        <div className="w-10 h-10 rounded-xl bg-violet-100 flex items-center justify-center" data-id="element-1773">
          <Lightbulb className="w-5 h-5 text-violet-600" data-id="element-1774" />
        </div>
        <h2 className="text-xl font-black text-slate-800" data-id="element-1775">Slimme Leertips</h2>
      </div>

      {errorPatterns.length === 0 ? <Card className="p-6 text-center bg-slate-50 border-dashed border-2 border-slate-200 rounded-2xl shadow-sm" data-id="element-1776">
          <p className="text-slate-500 font-medium" data-id="element-1777">
            Geen specifieke tips — je doet het geweldig! 🌟
          </p>
        </Card> : <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1778">
          {errorPatterns.map((pattern, i) => <motion.div key={`${pattern.errorType}-${i}`} variants={itemVariants} data-id="element-1779">
              <Card className="p-5 h-full flex flex-col border-2 border-slate-100 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow" data-id="element-1780">
                <div className="flex items-center gap-3 mb-3" data-id="element-1781">
                  <div className={`w-10 h-10 rounded-xl flex items-center justify-center text-xl shadow-sm ${pattern.moduleColor.replace('bg-', 'bg-opacity-20 text-').replace('500', '700')} bg-opacity-20`} data-id="element-1782">
                    {pattern.moduleIcon}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-1783">
                    <h4 className="font-bold text-slate-800 truncate" data-id="element-1784">
                      {pattern.familyName}
                    </h4>
                    <p className="text-xs text-slate-500 font-medium" data-id="element-1785">
                      Tip voor jou
                    </p>
                  </div>
                </div>
                <div className="bg-violet-50 rounded-xl p-4 flex-1" data-id="element-1786">
                  <p className="text-violet-800 text-sm font-medium leading-relaxed" data-id="element-1787">
                    {pattern.recommendation}
                  </p>
                </div>
              </Card>
            </motion.div>)}
        </div>}
    </div>;
}